export default "__VITE_ASSET__3$y6aas1__"